export interface AuthorProfile {
  id: string;
  name: string;
  title: string;
  bio: string;
  photo: string;
  url?: string;
  twitter?: string;
  linkedIn?: string;
}

export const TOOLNOVA_AUTHOR: AuthorProfile = {
  id: 'reece-satran',
  name: 'Reece Satran',
  title: 'Founder, ToolNova.ai',
  bio: "Reece is the founder of ToolNova.ai and an avid AI enthusiast based in Washington State. He built ToolNova to help everyday people cut through the noise and find AI tools that actually work for real life.",
  photo: 'https://storage.readdy-site.link/project_files/4a87f1ed-ca71-4188-a2d0-a2c423e3889a/0843357d-b0b2-4257-8c94-8b81daf15e1b_IMG_2270.png?v=0dead78c437552edd7e15c3e49587cbc',
  url: 'https://toolnova.ai/about',
  twitter: 'https://x.com/toolnovaHQ',
  linkedIn: '',
};
